import React, { useEffect, useState } from 'react';
import { useUiState } from './../../../helpers/useUiState';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, theme, Typography } from 'antd';
import { useAuthProvider } from './../../Auth/hooks/useAuthProvider';
import { useAuthSrv } from 'pages/Auth/hooks/useAuthSrv';
import { useTranslation } from 'react-i18next';
import { handleErrorNavigation } from 'pages/ErrorPage/ErrorHandler';

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;
const AuthPage = () => {
    const { isAppLoading } = useUiState();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { authStep } = state;
    const { generateAnonymousAuthToken } = useAuthSrv();
    const { updateAuthSession, updateAuthWizard } = useAuthProvider();
    const { token } = useToken();
    const screens = useBreakpoint();
    const { t } = useTranslation();
    const styles = {
        container: {
            margin: '0 auto',
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: '380px',
            zIndex: 100
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: 'center',
            width: '100%',
        },
        forgotPassword: {
            float: 'right',
        },
        header: {
            marginBottom: token.marginXL,
        },
        section: {
            alignItems: 'center',
            backgroundColor: token.colorBgContainer,
            display: 'flex',
            height: screens.sm ? "100vh" : "100vh",
            padding: screens.md ? `${token.sizeXXL}px 0px` : '0px',
        },
        text: {
            color: token.colorTextSecondary,
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
        },
    };
    useEffect(() => {
        isAppLoading(true);
        generateAnonymousAuthToken()
            ?.then((res: any) => {
                console.log('res12-=-', res.data);
                isAppLoading(false);
                if (res.data.Authenticated === 'true' && res.data.Access_Token) {
                    const authSession = {
                        auth_progress: 'PROGRESS',
                        access_token: res.data.Access_Token,
                        user_name: res.data.MemberName,
                    };
                    updateAuthSession(authSession);
                    console.log('authStep', authStep);
                    updateAuthWizard(authStep.onSuccess);
                }
                else {
                    const e = new Error("The requested resource is no longer available");
                    handleErrorNavigation(e, navigate, t);
                }
            })
            .catch((e) => {
                handleErrorNavigation(e, navigate, t);
            });
    }, []);

    return (
        <section style={styles.section}>

            <div style={styles.container}>
                <div style={styles.header}>
                    <Title style={styles.title}>{t('AUTHANONYMOUS.TITLE')}</Title>
                    <Text style={styles.text}>{t('AUTHANONYMOUS.CONTENT')}</Text>
                </div>

            </div>
        </section>
    );
};
export default AuthPage;
